import { useCallback, useState } from 'react'

import { router } from '@inertiajs/react'
import { isRole } from 'helpers/typeguards'
import { i18n } from 'shared/I18n'

import { type Role, type User } from 'helpers/interfaces'

import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'

import { TextField, type TextFieldProps } from '@oxfordmedicalsimulation/oms-fe-components'

// Switches the user's acting role, for users with more than one
export const RoleSelect = ({ user }: { user: User }) => {
  const [selectedRole, setSelectedRole] = useState<Role>(user.role)
  const onRoleChange = useCallback<NonNullable<TextFieldProps['onChange']>>(async (event) => {
    const newRole = event.target.value

    if (!isRole(newRole)) {
      throw new Error('Invalid role')
    }

    setSelectedRole(newRole)
    router.post('/switch_role', { role: newRole })
  }, [])

  if (user.roles.length < 2) return null

  return (
    <TextField
      size="small"
      value={selectedRole}
      onChange={onRoleChange}
      select
      fullWidth
      slotProps={{ htmlInput: { 'aria-label': 'Role' } }}
    >
      {user.roles.map((role) => (
        <MenuItem key={role} value={role}>
          <Typography>{i18n.t(`users.roles.${role}`)}</Typography>
        </MenuItem>
      ))}
    </TextField>
  )
}
